
const Float = {
  "name": "Float",
  "kind": "SCALAR"
};
export default Float;